module.exports = __webpack_public_path__ + "img/sandbox-1.1d3fc46d.png";